var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 32,
    viewBox: "0 0 87 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9517 25.1023C24.5358 25.1023 22.5699 23.1378 22.5699 20.7238H15.6669C15.6669 26.9418 20.729 32 26.9517 32V25.1023Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7233 0.00312309H79.8203V6.6189H86.7233V0.00312309Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5697 20.7237C22.5697 14.5057 17.5076 9.44751 11.2848 9.44751C5.06208 9.44751 0 14.5057 0 20.7237H6.90298C6.90298 18.3097 8.86894 16.3452 11.2848 16.3452C13.7007 16.3452 15.6667 18.3097 15.6667 20.7237H22.5697Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0128 9.44752V10.333C41.6645 9.76299 40.1836 9.44752 38.6309 9.44752C32.4082 9.44752 27.3461 14.5057 27.3461 20.7238C27.3461 26.9418 32.4082 32 38.6309 32C40.1836 32 41.6645 31.6845 43.0128 31.1145V32H49.9158V9.44752H43.0128ZM38.6309 25.1023C36.215 25.1023 34.2491 23.1378 34.2491 20.7238C34.2491 18.3097 36.215 16.3452 38.6309 16.3452C41.0468 16.3452 43.0128 18.3097 43.0128 20.7238C43.0128 23.1378 41.0468 25.1023 38.6309 25.1023Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1861 0.00312309H55.2831V32H62.1861V0.00312309Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4548 0H67.5518V31.9999H74.4548V0Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7233 9.4475H79.8203V32H86.7233V9.4475Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 0.00314856V20.7237C15.6667 23.1378 13.7007 25.1023 11.2848 25.1023C8.86894 25.1023 6.91213 23.1469 6.9045 20.739C6.9045 20.7329 6.90908 20.7268 6.90908 20.7192C6.90908 20.7116 6.81909 20.5165 6.70623 20.5165H0.202849C0.0899858 20.518 0 20.6079 0 20.7192V20.7222C0 26.9418 5.06208 32 11.2848 32C17.5076 32 22.5697 26.9418 22.5697 20.7237V0.00314856H15.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7f4076057ee76798002757b1b7fc9986.svg";
export { ForwardRef as ReactComponent };